export default "__VITE_ASSET__CQpoSRZV__"